// src/features/projects/views/ProjectFlowEntry.jsx

import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "../../../auth/authContext";

import ProgramEngine from "../../engine/ProgramEngine";

import useProject from "../hooks/useProject";
import useProgram from "../hooks/useProgram";
import { ProgramScopedLocaleProvider } from "../../program-localization/ProgramScopedLocaleContext";

export default function ProjectFlowEntry() {

  const { slug, programSlug } = useParams();
  const navigate = useNavigate();
  const auth = useAuth();

  const apiUrl =
    process.env.REACT_APP_API_URL ||
    "http://localhost:5001/api";

  const token = auth.user?.token;

  const {
    project,
    programs,
    loading
  } = useProject({
    slug,
    token,
    apiUrl
  });

  const { program } = useProgram({
    programs,
    programSlug
  });

  const [programState, setProgramState] = useState(null);
  const [stateLoading, setStateLoading] = useState(true);

  useEffect(() => {

    if (!program || !project) return;

    const fetchState = async () => {

      try {

        setStateLoading(true);

        // 🔥 ÚNICA CRIDA (idempotent)
        const res = await fetch(
          `${apiUrl}/programs/${programSlug}/state?projectId=${project._id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        if (!res.ok) {
          throw new Error("Failed to load program state");
        }

        const data = await res.json();

        console.log("🧪 Program state loaded:", data);

        setProgramState(data);

      } catch (err) {

        console.error("❌ getProgramState error:", err);

      } finally {

        setStateLoading(false);

      }

    };

    fetchState();

  }, [program, project, programSlug, apiUrl, token]);

  // =====================================================
  // LOADING
  // =====================================================

  if (loading || stateLoading) {
    return <p>Loading...</p>;
  }

  if (!project) {
    return <p>Project not found.</p>;
  }

  if (!program) {
    return (
      <div className="app-module">
        <p>Program not found.</p>
        <button onClick={() => navigate(`/app/project/${slug}`)}>
          Back to project
        </button>
      </div>
    );
  }

  if (!programState) {
    return <p>Error loading program state</p>;
  }

  return (
    <ProgramScopedLocaleProvider
      projectSlug={slug}
      programSlug={programSlug}
      userCommunicationLanguage={auth.user?.communicationLanguage}
    >
      <ProgramEngine
        projectSlug={slug}
        projectMode={project.mode}
        projectUIFlow={project.uiFlow}
        program={programState.program}
        attempt={programState.attempt}
        programState={programState.state}
        apiUrl={apiUrl}
        token={token}
      />
    </ProgramScopedLocaleProvider>
  );

}
